import React, { FunctionComponent } from "react";
import { graphql } from "gatsby";
import { Layout } from "../../components/layout";
import { TopicCollection } from "../../components/topicCollection";
import { SEO } from "../../components/seo";
import { PostSnippetNode, toPostSnippet } from "../../data/posts";
import { TOPICS, TopicKey } from "../../topics";

export const pageQuery = graphql`
  query PostsByTopic($topic: String!) {
    allMarkdownRemark(
      sort: { fields: [frontmatter___publishedDate], order: DESC }
      filter: {
        fields: { collection: { eq: "blog" } }
        frontmatter: { topic: { eq: $topic } }
      }
    ) {
      nodes {
        ...PostSnippet
      }
    }
  }
`;

interface Page {
  data: { allMarkdownRemark: { nodes: PostSnippetNode[] } };
  pageContext: { topic: TopicKey };
}

export const Page: FunctionComponent<Page> = ({
  data,
  pageContext: { topic },
}) => {
  const posts = data.allMarkdownRemark.nodes.map(toPostSnippet);
  return (
    <>
      <SEO
        title={TOPICS[topic].name}
        description={TOPICS[topic].description}
        image={posts[0]?.img.src || "/logo.png"}
      />
      <Layout>
        <TopicCollection topic={topic} posts={posts} />
      </Layout>
    </>
  );
};

export default Page;
